import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { DataView, DataViewProps } from 'src/components/DataView/DataView';
import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

type ResourceNameViewProps = DataViewProps & {
    resourceStore: ResourceStore;
    value?: string | string[] | null;
};

export const ResourceNameView = ({
    resourceStore,
    value,
    ...props
}: ResourceNameViewProps) => {
    const resourceName = useMemo<React.ReactNode | undefined | null>(() => {
        if (!value) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map((val, index) => (
                <React.Fragment key={val}>
                    <Trans i18nKey={resourceStore.itemsMap[val]?.label} />
                    {index !== value.length - 1 && ', '}
                </React.Fragment>
            ));
        }

        return <Trans i18nKey={resourceStore.itemsMap[value]?.label} />;
    }, [value, resourceStore]);

    return <DataView {...props} value={resourceName} />;
};
